import * as React from "react";
import { MapMarkersProps, MapMarker, Position } from "../typings";
import { Marker, HotelMarker, PlaceMarker } from "uitk-react-map";
import { ActivityMarker } from "./ActivityMarker";
import { MAP_CARD_ID } from "../cards/MapMarkerCard";

export enum MarkerIcon {
  HOTEL,
  POI,
  ACTIVITY
}

export class MapMarkers extends React.Component<MapMarkersProps> {
  private markers: Marker[] = [];
  private selectedMarker: Marker;
  private zIndex: number = 9999;
  private isMobile: boolean;

  public render() {
    const { google, map, hotels, pois, activities, selectMarker, isMobile } = this.props;
    this.isMobile = isMobile;
    if (map && google) {
      this.removeMarkers();
      if (hotels) {
        hotels.map((marker, index) => this.createGoogleMapsMarker(marker, selectMarker, index));
      }
      if (pois) {
        pois.map((marker, index) => this.createGoogleMapsMarker(marker, selectMarker, index));
      }
      if (activities) {
        activities.map((marker, index) => this.createGoogleMapsMarker(marker, selectMarker, index));
      }
    }

    return false;
  }

  private removeMarkers() {
    this.markers.forEach(marker => {
      if (marker !== this.selectedMarker) {
        marker.marker.setMap(null);
      }
    });
    this.markers = [];
  }

  private createGoogleMapsMarker(marker: MapMarker, select: string, index: number) {
    if (!marker) {
      return null;
    }

    const pin = this.createPin(marker, index);
    if (!pin) {
      return null;
    }

    this.markers.push(pin);

    const { google, onSelect, map } = this.props;
    pin.marker.position = pin.marker.getPosition();

    if (select.length && select === marker.cardContent.id) {
      this.focusMarker(pin);
      this.panToPosition(map, pin.marker.getPosition());
    } else if (google.maps && google.maps.event) {
      google.maps.event.addDomListener(pin.marker.anchor, "click", () => {
        if (marker.cardContent) {
          this.focusMarker(pin);
          onSelect(marker.cardContent);
          this.panToPosition(map, pin.marker.getPosition());
        }
      });
    }

    return pin.marker;
  }

  private focusMarker(pin: Marker) {
    if (this.selectedMarker) {
      this.selectedMarker.marker.setMap(null);
    }
    this.selectedMarker = pin;
    this.selectedMarker.focus(this.zIndex);
  }

  private panToPosition(map: any, position: Position) {
    map.panTo(position);
    if (this.isMobile) {
      const el = document.getElementById(MAP_CARD_ID);
      const offsetY: number = el ? el.offsetHeight / 2 : 0;
      map.panBy(0, offsetY);
    }
  }

  private createPin(marker: MapMarker, zIndex: number) {
    const { google, map } = this.props;
    const pinProps = {
      google,
      map,
      position: marker.position,
      zIndex
    };

    switch (marker.icon) {
      case MarkerIcon.HOTEL:
        return new HotelMarker({ ...pinProps });
      case MarkerIcon.POI:
        return new PlaceMarker({ ...pinProps });
      case MarkerIcon.ACTIVITY:
        return new ActivityMarker({ ...pinProps });
      default:
        return null;
    }
  }
}

export default MapMarkers;
